const ModeType = {
  LIST: "list",
  MAP: "map",
};

const SortName = {
  State: "state",
  Inbound: "inbound",
  Intrastate: "intrastate",
  Outbound: "outbound",
};

export {
  ModeType, 
  SortName
};



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/modelData.js